import ParitairComite from './ParitairComite';

export default ParitairComite;
